var themes = {
  DARK: 'dark',
  DARK_BLUE: 'dark hm-dark-blue',
  LIGHT: 'light'
};
export default themes;
export function isValidTheme(theme) {
  return theme === themes.LIGHT || theme === themes.DARK_BLUE || theme === themes.DARK;
}